import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-items-are-unavailable',
    template: `
        <div
            class="flex min-h-[200px] flex-col items-center justify-center p-8 text-center"
        >
            <div
                class="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"
            >
                <i [class]="iconClass + ' text-xl text-slate-400'"></i>
            </div>
            <p class="font-medium text-slate-700">
                {{ itemsAreUnavailableMessage | translate }}
            </p>
            @if (description) {
                <p class="mt-1 text-sm text-slate-500">
                    {{ description | translate }}
                </p>
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ItemsAreUnavailableComponent {
    @Input() public itemsAreUnavailableMessage =
        'translate_could_not_find_any_items';
    @Input() public description = '';
    @Input() public iconClass = 'fa-light fa-inbox';
}
